var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingPageMissionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25362_29315",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H55V55H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25362_29315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0341 29.5796C50.0341 43.1739 39.0137 54.1943 25.4193 54.1943C11.8251 54.1943 0.804688 43.1739 0.804688 29.5796C0.804688 15.9852 11.8251 4.96483 25.4193 4.96483C39.0137 4.96483 50.0341 15.9852 50.0341 29.5796Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4189 47.4282C35.2606 47.4282 43.2675 39.4213 43.2675 29.5796C43.2675 19.738 35.2606 11.7311 25.4189 11.7311C15.5772 11.7311 7.57031 19.738 7.57031 29.5796C7.57031 39.4213 15.5772 47.4282 25.4189 47.4282Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4183 40.6621C19.3075 40.6621 14.3359 35.6905 14.3359 29.5797C14.3359 23.4688 19.3075 18.4972 25.4183 18.4972C31.5292 18.4972 36.5008 23.4688 36.5008 29.5797C36.5008 35.6905 31.5292 40.6621 25.4183 40.6621Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4179 33.896C23.0379 33.896 21.1016 31.9597 21.1016 29.5797C21.1016 27.1996 23.0379 25.2634 25.4179 25.2634C27.7978 25.2634 29.7343 27.1996 29.7343 29.5797C29.7343 31.9597 27.7978 33.896 25.4179 33.896Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.418 29.5796L52.3162 2.68137",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2387 0.917745L42.8387 6.31763C42.6067 6.54966 42.4855 6.87031 42.5062 7.19784L42.8189 12.1802L49.1808 5.81822L48.8886 1.16342C48.868 0.835889 48.4708 0.685713 48.2387 0.917745Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0827 6.76055L48.6829 12.1604C48.4508 12.3925 48.1303 12.5136 47.8026 12.4931L42.8203 12.1804L49.1823 5.81846L53.8371 6.11065C54.1647 6.13117 54.3148 6.52852 54.0827 6.76055Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageMissionIcon);
export default __webpack_public_path__ + "static/media/LandingPageMissionIcon.3f25d9e02d45023486029dd44c581f4b.svg";
export { ForwardRef as ReactComponent };